/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const GradedAssignmentIcon = /*#__PURE__*/ createSvgIcon(
  'GradedAssignmentIcon',
  {
    ltr: {
      small: ({ id }) => (
        <>
          <g
            clipPath={`url(#${id}_0)`}
            fillRule="evenodd"
            clipRule="evenodd"
            fill="currentColor"
          >
            <path d="M8 1.5a6.5 6.5 0 100 13 6.5 6.5 0 000-13zM.5 8a7.5 7.5 0 1115 0 7.5 7.5 0 01-15 0z" />
            <path d="M7.777 3.527a.72.72 0 01.871.332l.023.041.762 2.34h2.19a.7.7 0 01.581.26.72.72 0 01-.018.96l-.03.033-1.964 1.475.696 2.242a.69.69 0 01-.028.597l-.01.019-.012.018a.72.72 0 01-1.014.196l-.01-.007-1.81-1.398-1.844 1.459-.045.023a.7.7 0 01-.578.023.72.72 0 01-.47-.868l.004-.015.76-2.28L3.883 7.54l-.027-.027a.74.74 0 01-.213-.456.71.71 0 01.71-.807h.006-.009 2.21l.755-2.256L7.313 4l.003-.008-.001.003a.73.73 0 01.462-.467zm.228 1.557L7.28 7.25H5.174L7.01 8.603 6.311 10.7l1.685-1.335 1.673 1.293-.64-2.066 1.799-1.352H8.707l-.702-2.156z" />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h16v16H0z" />
            </clipPath>
          </defs>
        </>
      ),
      medium: ({ id }) => (
        <>
          <g
            clipPath={`url(#${id}_0)`}
            fillRule="evenodd"
            clipRule="evenodd"
            fill="currentColor"
          >
            <path d="M10 1.5a8.5 8.5 0 100 17 8.5 8.5 0 000-17zM.5 10a9.5 9.5 0 1119 0 9.5 9.5 0 01-19 0z" />
            <path d="M9.527 4.454a.78.78 0 011.221.4l.985 3.026h2.937a.78.78 0 01.61.263.77.77 0 01-.015 1.069l-.025.026-2.589 1.95.927 3.014a.74.74 0 01-.024.627l-.011.023-.014.021a.783.783 0 01-1.087.223l-.013-.01-2.426-1.863-2.46 1.925-.05.024a.77.77 0 01-.614.019.78.78 0 01-.513-.935l.004-.019 1.039-3.051L4.79 9.263l-.012-.01a.78.78 0 01-.279-.585v-.023a.78.78 0 01.83-.755h2.928l.994-3.037a.78.78 0 01.275-.4zm4.526 4.426h-3.046L9.999 5.784 8.982 8.89h-3.01l2.62 1.924-1.041 3.059 2.446-1.916 2.415 1.856-.923-3.001 2.564-1.932z" />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h20v20H0z" />
            </clipPath>
          </defs>
        </>
      ),
      large: ({ id }) => (
        <>
          <g
            clipPath={`url(#${id}_0)`}
            fillRule="evenodd"
            clipRule="evenodd"
            fill="currentColor"
          >
            <path d="M12 1.5C6.201 1.5 1.5 6.201 1.5 12S6.201 22.5 12 22.5 22.5 17.799 22.5 12 17.799 1.5 12 1.5zM.5 12C.5 5.649 5.649.5 12 .5S23.5 5.649 23.5 12 18.351 23.5 12 23.5.5 18.351.5 12z" />
            <path d="M11.599 5.272a.842.842 0 011.319.433l1.229 3.777h3.67a.842.842 0 01.662.285.83.83 0 01-.014 1.153l-.026.026-3.219 2.425 1.158 3.763a.794.794 0 01-.024.677l-.011.023-.014.021a.841.841 0 01-1.173.24l-.014-.009-3.03-2.327-3.062 2.398-.051.024a.83.83 0 01-.665.018.842.842 0 01-.558-1.01l.005-.018 1.293-3.802-3.26-2.395-.013-.01a.842.842 0 01-.3-.632L5.5 10.32v-.011a.842.842 0 01.9-.815h3.66l1.242-3.79a.842.842 0 01.297-.432zm5.794 5.21H13.42l-1.31-4.03-1.324 4.042H6.849l3.408 2.503-1.365 4.014 3.215-2.518 3.159 2.428-1.208-3.926 3.335-2.513z" />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h24v24H0z" />
            </clipPath>
          </defs>
        </>
      ),
    },
  },
  false
);

export default GradedAssignmentIcon;
